import styles from "./avatar-display.module.css"

const TIER_COLORS = {
  bronze: "#CD7F32",
  silver: "#C0C0C0",
  gold: "#FFD700",
  vip: "#FF1493",
}

const TIER_GLOWS = {
  bronze: "0 0 20px rgba(205, 127, 50, 0.6)",
  silver: "0 0 20px rgba(192, 192, 192, 0.6)",
  gold: "0 0 30px rgba(255, 215, 0, 0.8)",
  vip: "0 0 40px rgba(255, 20, 147, 0.9)",
}

export default function AvatarDisplay({ avatar, tier }) {

  return (
    <div className={styles.displayContainer}>
      <div className={styles.avatarWrapper}>
        <div
          className={styles.avatarFrame}
          style={{
            borderColor: TIER_COLORS[tier],
            boxShadow: TIER_GLOWS[tier],
          }}
        >
          <img src={avatar.url} alt="Avatar" className={styles.avatarImage} />
        </div>
        <div className={styles.tierBadge} style={{ backgroundColor: TIER_COLORS[tier] }}>
          {tier.toUpperCase()}
        </div>
      </div>

      <div className={styles.infoSection}>
        <h3 className={styles.infoTitle}>Avatar Details</h3>
        <div className={styles.infoGrid}>
          <div className={styles.infoItem}>
            <span className={styles.infoLabel}>Tier:</span>
            <span className={styles.infoValue}>{tier.toUpperCase()}</span>
          </div>
          {avatar.customization && (
            <>
              {avatar.customization.background && (
                <div className={styles.infoItem}>
                  <span className={styles.infoLabel}>Background:</span>
                  <span className={styles.infoValue}>#{avatar.customization.background}</span>
                </div>
              )}
              {avatar.customization.skinColor && (
                <div className={styles.infoItem}>
                  <span className={styles.infoLabel}>Skin Color:</span>
                  <span className={styles.infoValue}>#{avatar.customization.skinColor}</span>
                </div>
              )}
              {avatar.customization.hairstyle && (
                <div className={styles.infoItem}>
                  <span className={styles.infoLabel}>Hairstyle:</span>
                  <span className={styles.infoValue}>{avatar.customization.hairstyle}</span>
                </div>
              )}
              {avatar.customization.hairColor && (
                <div className={styles.infoItem}>
                  <span className={styles.infoLabel}>Hair Color:</span>
                  <span className={styles.infoValue}>#{avatar.customization.hairColor}</span>
                </div>
              )}
              {avatar.customization.beard && (
                <div className={styles.infoItem}>
                  <span className={styles.infoLabel}>Beard:</span>
                  <span className={styles.infoValue}>{avatar.customization.beard}</span>
                </div>
              )}
              {avatar.customization.clothing && (
                <div className={styles.infoItem}>
                  <span className={styles.infoLabel}>Clothing:</span>
                  <span className={styles.infoValue}>{avatar.customization.clothing}</span>
                </div>
              )}
              {avatar.customization.clothingColor && (
                <div className={styles.infoItem}>
                  <span className={styles.infoLabel}>Cloth Color:</span>
                  <span className={styles.infoValue}>{avatar.customization.clothingColor}</span>
                </div>
              )}
              {avatar.customization.eyes && (
                <div className={styles.infoItem}>
                  <span className={styles.infoLabel}>Eyes:</span>
                  <span className={styles.infoValue}>{avatar.customization.eyes}</span>
                </div>
              )}
              {avatar.customization.mouth && (
                <div className={styles.infoItem}>
                  <span className={styles.infoLabel}>Mouth:</span>
                  <span className={styles.infoValue}>{avatar.customization.mouth}</span>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  )
}
